import { Theme } from "@mui/material/styles";
import { neutral } from "app/themes/colors";

export const getDialogsComponents = (sunoTheme: Theme) => ({
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        display: "flex",
        backgroundColor: neutral[50],
        borderBottom: `1px solid ${neutral[100]}`,
        padding: sunoTheme.spacing(2),
        "&+.MuiDialogContent-root": {
          paddingTop: sunoTheme.spacing(3),
        },
      },
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        paddingTop: `${sunoTheme.spacing(3)} !important`,
        paddingBottom: sunoTheme.spacing(10),
        paddingLeft: sunoTheme.spacing(5),
        paddingRight: sunoTheme.spacing(5),
      },
    },
  },
});
